import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { IMetaAdsSummary } from '../../extViewmodels/sdk/models/Ads';
import { useUserSession } from '../../models/hooks/appStateHooks';

const BASE_QUERY_KEY = 'getMetaAdsReportSummary';

export const useGetMetaAdsReportSummary = ({
	impersonationContext,
	startDate,
	endDate,
	enabled = true,
}: {
	impersonationContext?: Api.IImpersonationContext;
	startDate?: Date;
	endDate?: Date;
	enabled?: boolean;
}) => {
	const userSession = useUserSession();

	return useQuery({
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<IMetaAdsSummary>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `ads/providers/meta/metrics/summary?startDate=${startDate?.toISOString().split('T')[0]}&endDate=${endDate?.toISOString().split('T')[0]}`,
				}),
				'GET'
			);
		},
		queryKey: [BASE_QUERY_KEY, impersonationContext, startDate?.toISOString(), endDate?.toISOString()],
		enabled: enabled && !!startDate && !!endDate,
		refetchOnWindowFocus: false,
	});
};
